import { defineComponent, ref, useCssModule } from '@nuxtjs/composition-api';
import { useAudio } from '~/composables';
import { humanizeSeconds } from '~/utils';
export default defineComponent({
    name: 'PodcastItem',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
        theme: {
            default: 'light',
            type: String,
            validator: (value) => {
                return ['dark', 'light'].includes(value);
            },
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Audio.
         */
        const audio = useAudio(props.item.file.uri);
        /**
         * Component key.
         */
        const componentKey = ref(0);
        /**
         * Handles "update" event.
         */
        audio.on('update', () => {
            componentKey.value += 1;
        });
        function playPause() {
            audio.playPause();
            const event = new CustomEvent('playPause', {
                detail: props.item,
            });
            window.dispatchEvent(event);
        }
        return {
            audio,
            componentKey,
            css,
            humanizeSeconds,
            playPause,
        };
    },
});
